module.exports = __webpack_public_path__ + "static/media/vitalCreditMobile1.20b7b4eb.svg";